__turbopack_context__.v({
  "backLink": "HeroSection-module-scss-module__Qgf9Yq__backLink",
  "categoryBadge": "HeroSection-module-scss-module__Qgf9Yq__categoryBadge",
  "copyLinkButton": "HeroSection-module-scss-module__Qgf9Yq__copyLinkButton",
  "copyLinkIcon": "HeroSection-module-scss-module__Qgf9Yq__copyLinkIcon",
  "copyLinkLabel": "HeroSection-module-scss-module__Qgf9Yq__copyLinkLabel",
  "heroContent": "HeroSection-module-scss-module__Qgf9Yq__heroContent",
  "heroControls": "HeroSection-module-scss-module__Qgf9Yq__heroControls",
  "heroInner": "HeroSection-module-scss-module__Qgf9Yq__heroInner",
  "heroTitle": "HeroSection-module-scss-module__Qgf9Yq__heroTitle",
  "metaLeft": "HeroSection-module-scss-module__Qgf9Yq__metaLeft",
  "metaRow": "HeroSection-module-scss-module__Qgf9Yq__metaRow",
  "time": "HeroSection-module-scss-module__Qgf9Yq__time",
});
